import(/* webpackMode: "eager" */ "/app/src/app/about/page.tsx");
